import {Component} from '@angular/core';
import {GlobalSubscriptionService} from "@services/subscriptions/global-subscription.service";
import {UpdateSubscriptionTypesEnum} from "@interfaces/orders/enums/update-subscription-types.enum";
import {Subscription} from "rxjs";
import {TranslateModule} from '@ngx-translate/core';
import {ApplicationSvgComponent} from "./application-svg/application-svg.component";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.component.scss'],
  standalone: true,
  imports: [ TranslateModule, ApplicationSvgComponent]
})
export class FooterComponent {
  subject!: Subscription;
  add_big_padding!: boolean;
  constructor(
    private globalSubscriptionService: GlobalSubscriptionService) {
    this.subject = this.globalSubscriptionService.getMessage()
      .subscribe((data: { type: string, message: boolean }) => {
        if (data.type === UpdateSubscriptionTypesEnum.ADD_BOTTOM_BASKET) {
          this.add_big_padding = data.message;
        }
      })
  }

  navigateTpSocialLink(type: string): void {
    if (type === 'telegram') {
      window.open('https://t.me/clickmarketdelivery', '_blank')
    } else {
      window.open('https://vk.com/clickmarket', '_blank')
    }
  }

  navigateToPrivacyPolicyPage(): void {
    window.location.href = '/privacy-policy';
  }

}

